import { Injectable, inject } from '@angular/core';
import axios from 'axios';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';

export type GetUserResponse = {
  uuid: string;
  email: string;
  email_verified: string | null;
  name: string;
  has_2fa: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private authService = inject(AuthService);
  readonly userSubject = new BehaviorSubject<GetUserResponse | null>(null);

  constructor() {
    this.authService.loggedOut$
      .subscribe(() => {
        this.userSubject.next(null);
      });
  }

  async getUser(): Promise<GetUserResponse> {
    return await firstValueFrom(this.userSubject.pipe(
      filter((user): user is GetUserResponse => !!user),
    ));
  }

  async setUser(): Promise<void> {
    const url = environment.baseUrl + `/api/user`;
    const result = await axios.get<GetUserResponse>(url);
    this.userSubject.next(result.data);
  }
}
